<div class="form-group">
  <div class="form-group form-group--clean label-static is-empty"
       [class.has-error]="!!errors()">
    <label [htmlFor]="controlNameValue" class="control-label">
      {{ schemaTranslations() | schemaTranslationsGetFieldTranslations:controlNameValue }}
      @if (properties() | propertyIsFieldRequired:controlNameValue) {
        <span
            class="required">*</span>
      }
    </label>
  </div>
  <div class="date-parts" [formGroup]="dateFormGroup">
    @for (inputConfig of dateInputsConfig; track inputConfig) {
      <div
          class="form-group form-group--clean"
          [class.has-error]="!!dateFormGroup.controls[inputConfig.type].errors">
        <label [htmlFor]="controlNameValue + inputConfig.type"
               class="control-label control-label--relative">{{ inputConfig.label | translate }}</label>
        <input [formControlName]="inputConfig.type"
               class="form-control"
               type="number"
               [min]="inputConfig.min"
               [max]="inputConfig.max"
               [id]="controlNameValue + inputConfig.type"
               [required]="properties() | propertyIsFieldRequired:controlNameValue"
               [placeholder]="inputConfig.placeholder | translate"/>
        @if (submitted()) {
          @if (dateFormGroup.controls[inputConfig.type].errors) {
            <app-input-errors
                class="composite-date-app-input-errors"
                [errorsForField]="{
              error: 'minmax',
              min: inputConfig.min,
              max: inputConfig.max
              }"
                [translationKey]="'errors.composite_date'"/>
          }
        }
      </div>
    }
  </div>
</div>
